import React from 'react'
import { authRoles } from '../../auth/authRoles'

const dashboardRoutes = [
    {
        path: '/dashboard/alternative',
        component: React.lazy(() => import('./Analytics')),
        auth: authRoles.sa,
    },
    {
        path: '/dashboard/default',
        component: React.lazy(() => import('./Analytics2')),
        auth: authRoles.admin,
    },
    {
        path: '/dashboard/statsOrder',
        component: React.lazy(() => import('./StatsOrder')),
        auth: authRoles.test,
        accessPageName: 'ANALITIKA',
    },
    {
        path: '/dashboard/trendOrder',
        component: React.lazy(() => import('./TrendOrders')),
        auth: authRoles.test,
        accessPageName: 'ANALITIKA',
    },
    {
        path: '/dashboard/product-menu-analytics',
        component: React.lazy(() => import('./ProductMenuAnalytics')),
        auth: authRoles.test,
        accessPageName: 'ANALITIKA',
    },
    {
        path: '/dashboard/cohort-analytics',
        component: React.lazy(() => import('./CohortAnalytics')),
        auth: authRoles.test,
        accessPageName: 'ANALITIKA',
    },
    {
        path: '/dashboard/execution-time',
        component: React.lazy(() => import('./ExecutionTimeReport')),
        auth: authRoles.test,
        accessPageName: 'ANALITIKA',
    },
    {
        path: '/dashboard/inventory-management',
        component: React.lazy(() => import('./InventoryManagement')),
        auth: authRoles.admin,
    },
]

export default dashboardRoutes
